import { getDoc, doc } from "firebase/firestore";
import { db } from "@/fb";
import { config } from "@/utils/configuration/config";

export default class ParametricTableRepoFirebase {
  constructor() {
    //console.log("Construyendo ParametricTableRepoFirebase");
  }

  async getParametricTable(ref, callback) {
    const docRef = doc(db, config.firebaseConfig.parametricTablesCollectionName, ref);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      callback(ref, data);
    } //else {
    //   //console.log("ParametricTableRepoFirebase - No such document!");
    // }
  }
}